
import "../../../styles/productViewListItem.scss";
import CheckBox from "../../common/components/CheckBox";
import CounterField from "../../common/components/CounterField.jsx";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../common/components/ResponsiveRows";
import moment from "moment";

/**
 * A counter designed for ordered items
 * 
 * @param {object} props
 * @returns {node}
 */
function CounterNoOfDollies({customer, updateNoOfDollies}) {

    /**
     * updates produced qty
     * 
     * @param {object} change
     * @returns {undefiend}
     */
    function onEditNoOfDollies(change) {
        updateNoOfDollies(customer, change.value); 
    }

    return (
        <CounterField onEdit={onEditNoOfDollies} value={customer.noOfDollies} border={false} invisibleBackground={true} alwaysShowInputField={true} minValue={0}/>
    );
}
CounterNoOfDollies.propTypes = {
    customer: PropTypes.object,
    updateNoOfDollies: PropTypes.func,
};

export class CustomerListHeader extends React.PureComponent {
    render() {
        const {
            localization,
            normalCratesAlias,
            mediumCratesAlias,
            smallCratesAlias,
            treated,
        } = this.props;

        return (
            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                <div className="container">
                    <div className="list" style={{ display: "flex"}} >
                        <div style={{ flexBasis: "65%"}}>
                            <ResponsiveRows gutters={false} >
                                <ResponsiveColumn lg={1}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {localization.text("dominos", "production", "select")}
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={1.5}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {localization.text("dominos", "production", "departmentStoreNo")}
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={2.5}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {localization.text("dominos", "production", "customerName")}
                                    </div>
                                </ResponsiveColumn> 
                                <ResponsiveColumn lg={2}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px", marginLeft:"35px" }}>
                                        {localization.text("dominos", "production", "noOfDollies")}
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={1.2}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {`${localization.text("dominos", "production", "numberOf")} ${normalCratesAlias}`}
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={1.2}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {`${localization.text("dominos", "production", "numberOf")} ${mediumCratesAlias}`}
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={1.2}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {`${localization.text("dominos", "production", "numberOf")} ${smallCratesAlias}`}
                                    </div>
                                </ResponsiveColumn>
                                { treated && (
                                    <ResponsiveColumn lg={1.2}>
                                        <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                            {localization.text("dominos", "production", "lastPrintedDate")}
                                        </div>
                                    </ResponsiveColumn> 
                                )}
                                                            
                            </ResponsiveRows>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CustomerListHeader.propTypes = {
    localization: Localization.propTypes.isRequired,
    normalCratesAlias: PropTypes.string,
    mediumCratesAlias: PropTypes.string,
    smallCratesAlias: PropTypes.string,
    treated: PropTypes.bool.isRequired,
};


export class CustomerListItem extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onCheckCustomer = this.onCheckCustomer.bind(this);
    }
    onCheckCustomer(change){
        this.props.selectCustomer(this.props.customer, change);
    }

    render() {
        const {
            customer,
            style,
            updateNoOfDollies,
            treated,
        } = this.props;

        const lastPrintedDate = `${customer.lastPrintedDate && moment(customer.lastPrintedDate).format("DD.MM.YYYY HH:mm")}`;
        
        return (
            <div className="product-view-list-item-wrapper not-interactive" style={style}>
                <div className="container">
                    <div className="list" style={{ display: "flex"}} >
                        <div style={{ flexBasis: "65%"}}>
                            <ResponsiveRows gutters={false}>
                                <ResponsiveColumn lg={1}>
                                    <div className="checkbox-column">
                                        <CheckBox property={"selected"} source={customer} label="" onChange={this.onCheckCustomer} />
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={1.5}>
                                    <div className="label14 product-view-list-item product-view-list-item-prd-info_multiline_narrow">
                                        <div style={{ width: "100%" }}>
                                            {customer.departmentStoreNo}
                                        </div>
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={2.5}>
                                    <div className="label14 product-view-list-item">
                                        <div style={{ width: "100%" }}>
                                            {customer.customerName}
                                        </div>
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={2}>
                                    <div className="product-view-list-item-counter-field" style={{ float: "none" }}>
                                        <CounterNoOfDollies updateNoOfDollies={updateNoOfDollies} customer={customer} />
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={1.2}>
                                    <div className="label14 product-view-list-item">
                                        <div style={{ width: "100%" }}>
                                            {customer.noOfNormalCrates}
                                        </div>
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={1.2}>
                                    <div className="label14 product-view-list-item">
                                        <div style={{ width: "100%" }}>
                                            {customer.noOfMediumCrates}
                                        </div>
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={1.2}>
                                    <div className="label14 product-view-list-item">
                                        <div style={{ width: "100%" }}>
                                            {customer.noOfSmallCrates}
                                        </div>
                                    </div>
                                </ResponsiveColumn>  
                                { treated && (
                                    <ResponsiveColumn lg={1.2}>
                                        <div className="label14 product-view-list-item">
                                            <div style={{ width: "100%" }}>
                                                {lastPrintedDate}
                                            </div>
                                        </div>
                                    </ResponsiveColumn>      
                                )}
                            </ResponsiveRows>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CustomerListItem.propTypes = {
    localization: Localization.propTypes.isRequired,
    style: PropTypes.object,
    updateNoOfDollies: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    selectCustomer: PropTypes.func.isRequired,
    treated: PropTypes.bool.isRequired,
};

CustomerListItem.defaultProps = {
};